
<template>

  <svg class="w-full" xmlns="http://www.w3.org/2000/svg" width="2000" height="4" viewBox="0 0 2000 4" fill="none">

    <path class="stroke-12 sm:stroke-8 md:stroke-6 lg:stroke-4" d="M0 2H2000" stroke="url(#paint0_linear_8680_602)" />

    <path class="stroke-12 sm:stroke-8 md:stroke-6 lg:stroke-4" d="M0 2H2000" stroke="#0A7FEB" />

    <defs>

      <linearGradient id="paint0_linear_8680_602" x1="1.23747e-05" y1="2.5" x2="0.173333" y2="-11.5554" gradientUnits="userSpaceOnUse">

        <stop stop-color="#45C5E3"/>

        <stop offset="1" stop-color="#BFD630"/>

      </linearGradient>

    </defs>
    
  </svg>
   
</template>